// extracted by mini-css-extract-plugin
export default {"menu-navigation":"menu-navigation_menu-navigation__-3Bgj"};